import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedDSGroup: 0,
  allDatasources: [],
  selectedDS: null,
  selectedConnection: null,
  allconnection: [],
  selectedTable: null,
  selectedBlobContainer: null,
  allContainers: [],
  alltable: [],
  selectedColumns: [],
  allcolumns: [],
};

const taskSlice = createSlice({
  name: 'task',
  initialState,
  reducers: {
    setDataSourceGroup: (state, action) => {
      state.selectedDSGroup = action.payload;
    },
    setDataSource: (state, action) => {
      state.selectedDS = action.payload;
      state.selectedConnection = null;
      state.allconnection = [];
      state.selectedTable = null;
      state.alltable = [];
      state.selectedColumns = [];
      state.allcolumns = [];
      state.selectedBlobContainer = null;
      state.allContainers = [];

    },
    setAllDatasources: (state, action) => {
      state.allDatasources = action.payload;
    },
    setAllConnections: (state, action) => {
      state.allconnection = action.payload;
    },
    setSelectedConnections: (state, action) => {
      state.selectedConnection = action.payload;
      state.selectedTable = null;
      state.selectedBlobContainer = null;
      state.alltable = [];
      state.selectedColumns = [];
      state.allcolumns = [];
      state.allContainers = [];
    },
    setAllTables: (state, action) => {
      state.alltable = action.payload;
    },
    setAllContainers: (state, action) => {
      state.allContainers = action.payload;
    },
    setSelectedTable: (state, action) => {
      state.selectedTable = action.payload;
    },
    setSelectedBlobContainer: (state, action) => {
      state.selectedBlobContainer = action.payload;
    },
    setColumnList: (state, action) => {
      state.allcolumns = action.payload;
    },
    setSelectedColumns: (state, action) => {
      state.selectedColumns = action.payload;
    },
    resetState: () => initialState,
    patchAllData: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});


export const {
  setDataSourceGroup,
  setDataSource,
  setAllDatasources,
  setAllConnections,
  setSelectedConnections,
  setAllTables,
  setSelectedTable,
  setColumnList,
  setSelectedColumns,
  resetState,
  patchAllData,
  setSelectedBlobContainer,
  setAllContainers,
} = taskSlice.actions;


export default taskSlice.reducer;
